























































































































































































































































import Vue from "vue";
import {
  Alert,
  Confirm,
  GetClients,
  GetFilteredCountries,
  GetParks,
  IsAdmin,
} from "../App.vue";
import { gmapApi } from "vue2-google-maps";
import ContactUs from "../components/ContactUs.vue";

import {
  AjaxDelete,
  AjaxGet,
  AjaxPost,
  Clone,
  data,
  MonthString,
  SortOptions,
} from "../App.vue";
import CountryFilter from "../components/CountryFilter.vue";
import ClientFilter from "../components/ClientFilter.vue";
import {
  GetAddressURL, GetEmergencyShutdownRequestURL, GetParkActivateRequestURL,
  GetParkNoteURL,
  GetParkURL, GetSettingsURL, GetTransferURL
} from "../../../shared/Shared";
import ParkSite, { isDisabled } from "../../../shared/ParkSite";
import CountryCodes from "../../../shared/CountryCodes";
import { TextValue } from "../../../shared/TextValue";
import { World } from "../../../shared/World";
import Settings from "../../../shared/Settings";
import Client from "@/Client";
import Notes from "../components/Notes.vue";

const ParkStatusDisabled = "Disabled";
const ParkStatusTest = "Test";
const ParkStatusPublic = "Public";

let transferResolve: (value: string | PromiseLike<string>) => void;

class SiteDataClass {
  public isDirty: boolean = false;
  public Zoom: number = 14;

  public NewPark: ParkSite = new ParkSite();
  public SelectedParkName: string = "";
  public ParkSitesDictionary: { [id: string]: ParkSite } = {};
  public Councils: string[] = [];
  public ParkSitesList: ParkSite[] = [];

  public SelectedFilterCouncil: string = "";
  public SelectedFilterCountry: string = "";

  public PermanentWorlds: TextValue[] = [];
  public SeasonalWorlds: TextValue[] = [];
  public ComingSoonWorlds: TextValue[] = [];

  public Settings: Settings = new Settings();
  public Beacons: Beacon[] = [];

  public SelectedClient = "";

  // List of new clients (not the original "council" list)
  // public Clients: string[] = [];

  public ClientData: { [key: string]: Client } = {};

  public ParkNameFilter: string = "";

  public includedPermanentWorlds: string[] = [];
  public includedSeasonalWorlds: string[] = [];

}

interface LegendNameIcon {
  name: string;
  icon: string;
}

export default Vue.extend({
  name: "Sites",

  components: {
    CountryFilter,
    ClientFilter,
    ContactUs,
    Notes,
  },

  computed: {

    noteURL(): string {
      return GetParkNoteURL(this.SelectedParkName);
    },

    Countries: {
      get(): TextValue[] {
        return GetFilteredCountries(this.ParkSitesList);
      },
    },

    google: gmapApi,

    // A limited list of councils filtered by the new park country. requires at least one park to exist for a council
    NewParkCouncils: {
      cache: false,
      get(): string[] {
        const result: { [key: string]: boolean } = {};
        for (const park of this.ParkSitesList) {
          if (park.country === this.NewPark.country && park.council) {
            result[park.council] = true;
          }
        }
        return Object.keys(result).sort();
      },
    },

    Clients: {
      cache: false,
      get(): string[] {
        return Object.keys(this.ClientData);
      }
    },

    ClientsByCountry: {
      cache: false,
      get(): string[] {
        const result: { [key: string]: boolean } = {};

        // Searches through EVERY client, filtered by country
        for (const clientKey of this.Clients) {
          const client = this.ClientData[clientKey];
          if (!this.NewPark.country || this.NewPark.country === client.region) {
            result[clientKey] = true;
          }
        }

        return Object.keys(result).sort();
      },
    },

    ParkStatuses(): TextValue[] {
      if (this.IsNotAdmin() && this.ParkStatus !== ParkStatusPublic) {
        // Cannot set back to public
        return [
          {
            text: ParkStatusTest,
            value: ParkStatusTest,
            disabled: false,
          },
          {
            text: ParkStatusDisabled,
            value: ParkStatusDisabled,
            disabled: false,
          },
        ];
      }

      return [
        {
          text: ParkStatusPublic,
          value: ParkStatusPublic,
          disabled: this.IsNotAdmin(),
        },
        {
          text: ParkStatusTest,
          value: ParkStatusTest,
          disabled: false,
        },
        {
          text: ParkStatusDisabled,
          value: ParkStatusDisabled,
          disabled: false,
        },
      ];
    },

    AllParks: {
      cache: false,
      get(): ParkSite[] {
        const result: ParkSite[] = [];
        for (const park of this.ParkSitesList) {
          result.push(park);
        }
        return result;
      },
    },

    ParkStatus: {
      get(): string {
        if (this.SelectedPark && this.SelectedPark.isActive) {
          if (this.SelectedPark.isTestPark) {
            return ParkStatusTest;
          }
          return ParkStatusPublic;
        }
        return ParkStatusDisabled;
      },
      set(value: string) {
        if (this.SelectedPark) {
          switch (value) {
            case ParkStatusDisabled:
              this.SelectedPark.isTestPark = true;
              this.SelectedPark.isActive = false;
              break;
            case ParkStatusTest:
              this.SelectedPark.isTestPark = true;
              this.SelectedPark.isActive = true;
              break;
            case ParkStatusPublic:
              this.SelectedPark.isTestPark = false;
              this.SelectedPark.isActive = true;
              break;
          }
        }
      },
    },

    SelectedPark(): ParkSite | null {
      if (!this.SelectedParkName) {
        return null;
      }
      return this.ParkSitesDictionary[this.SelectedParkName];
    },
    centerLat: {
      cache: false,
      get(): number {
        const park = this.GetSelectedPark();
        if (park) {
          return park.centerLatitude;
        }
        return -36.85;
      },
    },
    centerLon: {
      cache: false,
      get(): number {
        const park = this.GetSelectedPark();
        if (park) {
          return park.centerLongitude;
        }
        return 174.76;
      },
    },
  },
  async mounted() {
    // @ts-ignore
    await this.$gmapApiPromiseLazy();
  },
  data() {
    return new SiteDataClass();
  },
  created() {
    AjaxGet<Settings>(GetSettingsURL(), false).then((settings) => {
      this.Settings = settings;
      // todo make this work on the sandbox as well?
      return AjaxGet<Beacon[]>("https://magical-parks.firebaseio.com/Beacons.json", false);
    }).then((beacons) => {
      this.Beacons = beacons;
      this.ReloadData(null);
    });
  },
  methods: {
    Alert(message: string) {
      Alert(message);
    },
    BeaconAtPark(parkId: string): string {
      for (const beacon of this.Beacons) {
        if (beacon.Park === parkId) {
          return beacon.Notes;
        }
      }
      return "None";
    },
    ConfirmShutdown(): void {
      Confirm("FINAL CONFIRMATION - ARE YOU ABSOLUTELY SURE YOU WANT TO DISABLE ALL PARKS?").then((confirm) => {

        this.$bvModal.hide("modal-emergency");

        if (confirm) {
          AjaxGet(GetEmergencyShutdownRequestURL(), true)
            .then(() => {
              Alert("Parks are now disabled. Please inform GeoAR Games.");
              this.ReloadData(null);
            })
            .catch(Alert);
        }

      });
    },
    ActivatePark(): void {
      Confirm("Are you sure you wish to ask for this park to be activated?")
        .then((result) => {
          if (!result) {
            return;
          }

          // New promise chain
          AjaxGet(GetParkActivateRequestURL(this.SelectedParkName), true)
            .then(() => {
              Alert("Geo AR Games have been notified of the request to activate a park.");
            })
            .catch(Alert);
        })
        .catch(Alert);
    },
    CanActivatePark(): boolean {
      return this.IsNotAdmin() && this.ParkStatus !== ParkStatusPublic;
    },
    IsAdmin(): boolean {
      return IsAdmin();
    },
    IsNotAdmin(): boolean {
      return !IsAdmin();
    },
    CanEditLocation(): boolean {
      return !this.CannotEditLocation();
    },
    CannotEditLocation(): boolean {
      if (this.IsAdmin()) {
        return false;
      }
      return this.ParkStatus === ParkStatusPublic;
    },
    UnsetFromDate(park: ParkSite) {
      park.fromDate = "";
      this.change();
    },
    UnsetToDate(park: ParkSite) {
      park.fromDate = "";
      this.change();
    },
    UnsetOpenTime(park: ParkSite) {
      park.openHour = "";
      this.change();
    },
    UnsetCloseTime(park: ParkSite) {
      park.closedHour = "";
      this.change();
    },
    // The radius of the park plus the radius of the allowed accuracy
    safetyRadius(park: ParkSite): number {
      if (park.overrideAccuracy) {
        return park.parkRadius + park.overrideAccuracy;
      } else if (data.Settings) {
        return park.parkRadius + data.Settings.Accuracy;
      }
      throw Error("Unable to get park radius");
    },
    //    parseFloat(park.parkRadius)+20
    Legend(): LegendNameIcon[] {
      const result: LegendNameIcon[] = [];
      result.push({
        name: "Selected",
        icon: "http://maps.google.com/mapfiles/ms/icons/blue-dot.png",
      });
      result.push({
        name: "Disabled",
        icon: "http://maps.google.com/mapfiles/ms/icons/red-dot.png",
      });
      result.push({
        name: "Test",
        icon: "http://maps.google.com/mapfiles/ms/icons/yellow-dot.png",
      });
      result.push({
        name: "Active",
        icon: "http://maps.google.com/mapfiles/ms/icons/green-dot.png",
      });
      return result;
    },

    Icon(park: ParkSite): string {

      // Blue = selected
      if (park.parkName === this.SelectedParkName) {
        return "http://maps.google.com/mapfiles/ms/icons/blue-dot.png";
      }

      // Red = disabled
      if (isDisabled(park)) {
        return "http://maps.google.com/mapfiles/ms/icons/red-dot.png";
      }

      // Yellow = test
      if (park.isTestPark) {
        return "http://maps.google.com/mapfiles/ms/icons/yellow-dot.png";
      }

      // Green = normal
      return "http://maps.google.com/mapfiles/ms/icons/green-dot.png";
    },
    GetSelectedPark(): ParkSite | null {
      return this.SelectedPark;
    },

    Transfer(): void {
      let cancelled = false;

      Confirm(
        "Are you sure you wish to transfer " +
        this.SelectedParkName +
        " from " +
        this.SelectedPark?.council +
        " to another client?"
      )
        .then((result) => {
          if (!result) {
            cancelled = true;
            return null;
          }

          return this.TransferPromise();
        })
        .then((result) => {
          if (!result || cancelled) {
            cancelled = true;
            return null;
          }

          return AjaxPost(GetTransferURL(this.SelectedParkName, result), {}, true);
        })
        .then(() => {
          if (cancelled) {
            return;
          }

          this.ReloadData(null);
        })
        .catch(Alert);
    },

    TransferPromise(): Promise<string> {
      this.$bvModal.show("modal-transfer");
      return new Promise<string>((resolve, reject) => {
        transferResolve = resolve;
      });
    },

    TransferOk() {
      transferResolve(this.SelectedClient);
    },

    TransferCancel() {
      transferResolve("");
    },

    Delete(): void {
      Confirm("Are you sure you wish to delete " + this.SelectedParkName + "?").then(
        (result) => {
          if (!result) {
            return null;
          }

          AjaxDelete(GetParkURL(this.SelectedParkName))
            .then(() => {
              this.ReloadData("");
            })
            .catch((err) => Alert(err));
        }
      );
    },
    ReloadData(nextPark: string | null): void {
      GetClients()
        .then((clients) => {
          this.ClientData = clients;
          return GetParks();
        })
        .then((sites) => {
          this.isDirty = false;
          this.ParkSitesDictionary = sites;
          this.ParkSitesList = [];
          const councilMap: { [id: string]: boolean } = {};

          for (const key of Object.keys(sites)) {
            const site = sites[key] as ParkSite;

            let country = "(Unknown country)";
            if (site.country) {
              country = site.country;
            }

            let council = "(Unknown client)";
            if (site.council) {
              council = site.council;
              councilMap[council] = true;
            }

            if (site.school) {
              council = site.school;
            }

            if (!site.centerLatitude) {
              site.centerLatitude = -36.8509;
            }
            if (!site.centerLongitude) {
              site.centerLongitude = 174.7645;
            }
            if (!site.parkRadius) {
              site.parkRadius = 20;
            }

            site.centerLatitude = parseFloat(site.centerLatitude.toString());
            site.centerLongitude = parseFloat(site.centerLongitude.toString());
            site.parkRadius = parseFloat(site.parkRadius.toString());

            site.DISPLAY_NAME =
              country +
              " - " +
              council +
              " - " +
              (site.displayName ? site.displayName : site.parkName);

            if (site.creator) {
              site.DISPLAY_NAME += " (" + site.creator + ")";
            }

            if (!site.excludedWorlds) {
              site.excludedWorlds = [];
            }

            this.ParkSitesList.push(site);
          }
          this.Councils = Object.keys(councilMap).sort();
          if (nextPark !== null) {
            this.SelectPark(nextPark);
          }
        })
        .catch(Alert);
    },

    FilterParkNames(): TextValue[] {
      const result: TextValue[] = [];

      result.push({
        text: "Please select a park",
        value: "",
        disabled: false,
      });

      const filterLower = this.ParkNameFilter
        ? this.ParkNameFilter.toLowerCase().trim()
        : "";

      for (const parksite of this.ParkSitesList) {
        if (!parksite.DISPLAY_NAME || !parksite.parkName) {
          continue;
        }

        if (
          this.SelectedFilterCountry &&
          this.SelectedFilterCountry !== parksite.country
        ) {
          continue;
        }

        if (
          this.SelectedFilterCouncil &&
          this.SelectedFilterCouncil !== parksite.council
        ) {
          continue;
        }

        if (
          filterLower &&
          parksite.DISPLAY_NAME.toLowerCase().trim().indexOf(filterLower) === -1 &&
          parksite.parkName.toLowerCase().trim().indexOf(filterLower) === -1
        ) {
          continue;
        }

        result.push({
          text: parksite.DISPLAY_NAME,
          value: parksite.parkName,
          disabled: false,
        });
      }
      return result;
    },

    Save(isNewSite: boolean) {
      if (!this.SelectedPark) {
        return;
      }

      const SaveObj = Clone(this.SelectedPark) as ParkSite;
      //      delete SaveObj.council; - not sure why council was deleted here
      delete SaveObj.DISPLAY_NAME;
      UpdateSite(SaveObj, isNewSite).then(() => this.ReloadData(null));
    },

    SelectPark(parkName: string) {
      if (this.isDirty) {
        if (
          confirm(
            this.SelectedParkName +
            " is not saved. OK = Save changes. Cancel = Discard changes."
          )
        ) {
          this.Save(false);
        } else {
          this.ReloadData(parkName);
        }
      }

      this.SelectedParkName = parkName;

      if (parkName) {
        this.Zoom = 19;
      } else {
        this.Zoom = 14;
      }

      const permanentWorldList: TextValue[] = [];
      const seasonalWorldList: TextValue[] = [];
      const comingSoonWorldList: TextValue[] = [];

      for (const key of Object.keys(this.Settings.Worlds)) {
        const world = this.Settings.Worlds[key];

        if (this.SelectedPark && this.SelectedPark.country) {
          if (world.regions && !world.regions[this.SelectedPark.country]) {
            continue;
          }
        }

        if (!world.enabled) {
          this.PushWorld(comingSoonWorldList, key, world, world.managerName);
          continue;
        }

        if (
          !world.start_day &&
          !world.end_day &&
          !world.start_month &&
          !world.end_month
        ) {

          this.PushWorld(permanentWorldList, key, world, world.managerName);

          // this is also a seasonal world
          if (world.seasonalVariant) {

            this.PushWorld(seasonalWorldList, key, world, world.seasonalVariant);

          }
        } else {

          this.PushWorld(seasonalWorldList, key, world, world.managerName);

        }
      }

      this.PermanentWorlds = permanentWorldList;
      this.SeasonalWorlds = seasonalWorldList;
      this.ComingSoonWorlds = comingSoonWorldList;

      this.refreshIncludedWorlds();

    },

    addExcludedWorlds(result: { [key: string]: boolean }, source: TextValue[], destination: string[]) {

      for (const sourceWorld of source) {
        if (!sourceWorld.value) {
          continue;
        }

        let isExcluded = true;
        for (const destinationWorld of destination) {
          if (destinationWorld === sourceWorld.value) {
            isExcluded = false;
            break;
          }
        }

        if (isExcluded) {
          result[sourceWorld.value] = true;
        } else {
          delete result[sourceWorld.value];
        }

      }
    },

    changedIncludedWorlds(isPermanentWorlds: boolean) {

      const park = this.SelectedPark;
      if (!park) {
        return;
      }

      const allWorlds: { [key: string]: boolean } = {};
      for (const currentlyExcludedWorld of park.excludedWorlds) {
        allWorlds[currentlyExcludedWorld] = true;
      }

      if (isPermanentWorlds) {
        this.addExcludedWorlds(allWorlds, this.PermanentWorlds, this.includedPermanentWorlds);
      } else {
        this.addExcludedWorlds(allWorlds, this.SeasonalWorlds, this.includedSeasonalWorlds);
      }

      const result: string[] = [];
      for (const world of Object.keys(allWorlds)) {
        result.push(world);
      }

      park.excludedWorlds = result;

      this.change();
      this.refreshIncludedWorlds();

    },

    populateIncludedWorldsList(source: TextValue[], excludedWorlds: string[]): string[] {
      const result: string[] = [];
      for (const world of source) {
        if (!world.value) {
          continue;
        }

        let isIncluded = true;
        for (const excluded of excludedWorlds) {
          if (excluded === world.value) {
            isIncluded = false;
            break;
          }
        }

        if (isIncluded) {
          result.push(world.value);
        }
      }
      return result;
    },

    refreshIncludedWorlds() {

      if (this.SelectedPark) {
        this.includedPermanentWorlds
          = this.populateIncludedWorldsList(this.PermanentWorlds, this.SelectedPark.excludedWorlds);
        this.includedSeasonalWorlds
          = this.populateIncludedWorldsList(this.SeasonalWorlds, this.SelectedPark.excludedWorlds);
      }

    },


    PushWorld(list: TextValue[], key: string, world: World, name: string) {

      const subWorldList: string[] = name.split(" / ");

      if (world.youtube) {
        for (let i = 0; i < subWorldList.length; i++) {
          if (i < world.youtube.length) {
            subWorldList[i] = "<a target='_blank' href='" + world.youtube[i] + "'>" + subWorldList[i] + "</a>";
          }
        }
      }

      list.push({
        text: subWorldList.join(" / "),
        value: key,
        disabled: false,
      });

    },

    SelectParkLabel(): string {
      if (!this.SelectedParkName) {
        return "Select Park";
      }
      return this.SelectedPark?.DISPLAY_NAME ?? "";
    },

    SelectedParkCountry(): string {
      if (!this.SelectedPark?.country) {
        return "Select Country";
      }
      return CountryCodes[this.SelectedPark.country];
    },

    SetCountry(Country: string) {
      if (this.SelectedPark) {
        this.SelectedPark.country = Country;
      }
      this.change();
    },

    SetPosition(Location: any) {
      if (this.CannotEditLocation()) {
        return;
      }
      if (this.SelectedPark) {
        this.SelectedPark.centerLatitude = Location.latLng.lat();
        this.SelectedPark.centerLongitude = Location.latLng.lng();
      }
      this.change();
    },

    UpdateAddressPromise(address: string): Promise<GooglePlaceLatLng | null> {

      return new Promise<GooglePlaceLatLng | null>((resolve, reject) => {

        AjaxGet<GooglePlaceLatLng | null>(
          GetAddressURL(address),
          false
        ).then(resolve).catch(reject);

      });

    },

    UpdateAddress() {

      if (this.SelectedPark) {
        this.UpdateAddressPromise(this.SelectedPark?.address).then((result) => {
          if (result) {
            if (this.SelectedPark) {
              this.SelectedPark.centerLatitude = result.lat;
              this.SelectedPark.centerLongitude = result.lng;
            }
            this.change();
          }
        }).catch(Alert);
      }

    },

    change() {
      this.isDirty = true;
      this.$forceUpdate();
    },

    OpenNewSiteModal(): void {
      this.NewPark = new ParkSite();
      this.$bvModal.show("modal-newsite");
    },

    OpenEmergencyShutdownModal(): void {
      this.$bvModal.show("modal-emergency");
    },

    SubmitNewSite(): void {

      if (!this.NewPark.parkName) {
        return;
      }

      if (!this.NewPark.address) {
        Alert("Please enter an address for this park");
        return;
      }

      // Try to find the address
      this.UpdateAddressPromise(this.NewPark.address).then((result) => {

        if (!result) {
          throw Error("Could not find address: " + this.NewPark.address);
        }

        this.NewPark.centerLatitude = result.lat;
        this.NewPark.centerLongitude = result.lng;
        this.NewPark.parkName = this.NewPark.parkName.trim();

        // If this site already exists
        if (this.ParkSitesDictionary[this.NewPark.parkName]) {
          //        const park = this.ParkSitesDictionary[this.NewPark.parkName];
          throw Error("A park with this name already exists in our system, please try a new name.");
          return;
        }

        // Making a new council
        if (this.NewPark.newCouncil) {
          this.NewPark.council = this.NewPark.newCouncil;
          delete this.NewPark.newCouncil;
        }

        return UpdateSite(this.NewPark, true);

      }).then(() => {

        this.ReloadData(this.NewPark.parkName);

      }).catch(Alert);

    },
  },
});

interface GooglePlaceLatLng {
  lat: number;
  lng: number;
}

function UpdateSite(SaveObj: ParkSite, initialCreation: boolean): Promise<boolean> {
  return new Promise<boolean>((resolve, reject) => {
    SaveObj.parkName = SaveObj.parkName.trim();
    SaveObj.modifier = data.FirebaseUser?.email ?? "";
    SaveObj.modifiedDate = MonthString();

    if (initialCreation) {
      SaveObj.creator = data.FirebaseUser?.email ?? "";
      SaveObj.creationDate = MonthString();
    }

    AjaxPost(
      GetParkURL(),
      SaveObj,
      true
    )
      .then(() => {
        resolve(true);
      })
      .catch((err) => {
        alert(err);
        resolve(true);
      });
  });
}

// Todo move elsewhere
interface Beacon {
  CheatBeacon: boolean;
  IgnoreGPS: boolean;
  Major: number;
  Minor: number;
  Notes: string;
  Park: string;
  UUID: string;
}

